export enum CertificateStatus {
  IN_REVIEW = 1,
  PENDING_PAYMENT = 2,
  REJECTED = 3,
  VALID = 4,
  EXPIRED = 5,
  HISTORICAL = 6,
  TRY_REQUEST = 999,
}
